<svg width="22" height="28" viewBox="0 0 22 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 14.3153V5L19.0987 4.09461C13.6589 1.50422 7.34114 1.50422 1.90133 4.09461L0 5V14.3153C0 18.4711 2.15021 22.3311 5.68374 24.5185L10.5 27.5L15.3163 24.5185C18.8498 22.3311 21 18.4711 21 14.3153Z" fill="#FBBB5B"/>
<g filter="url(#filter0_d)">
<path d="M6 13L9 16L16 9" stroke="white" stroke-width="2"/>
</g>
<defs>
<filter id="filter0_d" x="0.292892" y="4.29291" width="21.4142" height="19.1213" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="2.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
</filter>
</defs>
</svg>
